import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type UnusedCredentialsConfig = typeof UnusedCredentialsConfig._.Config;

export const UnusedCredentialsConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.UnusedCredentials,
  configSchema: z.object({
    inactiveDays: z.number(),
    userNamePatternFilter: patternFilterSchema.optional(),
  }),
});
